module.exports = require('../_components/@alicd/next-icon/lib/index.js');


//////////////////
// WEBPACK FOOTER
// ./~/@alicd/next/lib/icon/index.js
// module id = 92
// module chunks = 0